import React from 'react';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

const DetailsDescSwitches = ({clang, updateHeadingFilters, headingFilters}) => {
    // const selectFilterSelected = selectFilter ? selectFilter.options.filter(option => option.selected)[0] : false;
    const buttonFilters = headingFilters ? headingFilters.filter(filter => filter.type !== "SELECT") : false;

    const applyButtonFilter = (btn) => {
        updateHeadingFilters(btn.name);
    };

    const headingFiltersSelect = headingFilters ? headingFilters.filter(result => result.type === "SELECT") : false;
    const headingFiltersSelectLast = headingFiltersSelect ? headingFiltersSelect[headingFiltersSelect.length - 1] : false;
    const headingFiltersSelectLastOptions = headingFiltersSelectLast && headingFiltersSelectLast.options ? headingFiltersSelectLast.options : false;

    return (
        <div className="results__details__switches">
            {buttonFilters &&
                <ul className="results__details__switches__list">
                    {buttonFilters.map((buttonFilter, index) =>
                        !buttonFilter.common ?
                        <li key={index} className="results__details__switches__list-item">
                            <button type="button"
                                className={`${buttonFilter.selected ? 'results__details__switches__switch--active' : 'results__details__switches__switch'} `}
                                disabled={buttonFilter.selected}
                                onClick={() => applyButtonFilter(buttonFilter)}>
                                {headingFiltersSelectLastOptions && headingFiltersSelectLastOptions.filter(option => option.selected && option.id !== "0").length > 0 ? 
                                    lang[clang].headings_details[buttonFilter.name + '_SINGLE']
                                    : lang[clang].headings_details[buttonFilter.name]}
                            </button>
                        </li> : null)}
                </ul>}
        </div>
    );
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(DetailsDescSwitches);



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsDescSwitches.js